import React, {useState, useEffect, Fragment} from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, CardTitle, FormGroup, Label, Form } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import { paramPost } from "../../apiHelpers/commonApiHelper";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import { connect } from 'react-redux';


import { getSavedCampaigns, getPlayerList } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import Dropzone from "react-dropzone";
import {Checkbox, Tooltip} from 'antd';
import toastr from "toastr";
import SweetAlert from "react-bootstrap-sweetalert";

const SavedCampaigns = (props) => {

    useEffect(() => {
        props.getSavedCampaigns()
        props.getPlayerList()
    }, [])
    const [confirm_both, setconfirm_both] = useState(false);
    const [success_dlg, setsuccess_dlg] = useState(false);
    const [error_dlg, seterror_dlg] = useState(false);
    const [dynamic_title, setdynamic_title] = useState("");
    const [dynamic_description, setdynamic_description] = useState("");

    const [editModal, setEditModal] = useState(false);
    const [pending, setPending] = useState(false);
    const [playerId, setPlayerId] = useState(undefined);
    const [selectedCams, setSelectedCams] = useState([]);

    const [campaignId, setCampaignId] = useState(undefined);

    const [camId, setCamId] = useState(undefined);

    const clear = () => {
        setEditModal(false);
        setCamId(undefined);
        setSelectedCams([]);
    }

    const handlePublishing = (id) => {
        setCamId(id);
        setEditModal(true);
    }

    const handlePublishingSave = () => {
        if(selectedCams.length === 0) {
            toastr.warning("Please select players", "Warning");
            return false
        }
        setPending(true);
        paramPost('/api/v1/campaigns/publish', {campaigns: selectedCams})
            .then((result) => {
                setPending(false);
                if(result.data.success) {
                    toastr.success("Campaign published successfully", "Success");
                    clear();
                } else {
                    if(result.status === 204) {
                        toastr.info("Campaigns are already published", "Info");
                        return
                    }
                    toastr.error("Something went wrong. Please try again", "Error");
                }
            })
            .catch(err => {
                setPending(false);
                toastr.error("Something went wrong. Please try again", "Error");
            })
    }

    const handleCheckBox = (e, playerId) => {
        if(e.target.checked && (selectedCams.length === 0 || selectedCams.some(item => item.player_id !== playerId))) {
            setSelectedCams(selectedCams => [...selectedCams, {player_id: playerId, campaign_id: camId}]);
        }
        if(!e.target.checked) {
            if(props.playerList && props.playerList.length === 1) {
                setSelectedCams([]);
            }
            setSelectedCams(selectedCams => [...selectedCams.filter( el => el.player_id === playerId)]);
        }
    }

    const contentList = () => {
        if (props.playerList) {
            return props.playerList.map((item, index) => {
                return (
                    <Tr key={index} className="text-left">
                        <Td>
                            <span className="mr-2"><Checkbox onChange={(e) => handleCheckBox(e, item.player_id)}></Checkbox></span>
                            {item.player_name}
                        </Td>
                        <Td>{moment(item.created_at).format("llll")}</Td>
                    </Tr>
                );
            });
        }
    };

    const campaignList = () => {
        if(props.saved_campaigns) {
            return props.saved_campaigns.map((item, index) => {
                return (
                    <Tr key={index} className="text-left">
                        <Td>
                            {item.name}
                        </Td>
                        <Td>
                            {item.media_campaigns[0].medium.media_type === "image" ? (
                                <img src={item.media_campaigns[0].medium.url} style={{width: "85px", height: "60px"}} />
                            ) : item.media_campaigns[0].medium.media_type === "video" ? (
                                <video style={{width: "85px", height: "60px"}}>
                                    <source src={item.media_campaigns[0].medium.url} type="video/mp4"/>
                                </video>
                            ) : ""}
                        </Td>
                        <Td>
                            {item.media_campaigns.length}
                        </Td>
                        <Td>{moment(item.created_at).format("lll")}</Td>
                        <Td>
                            <Tooltip title="Publish to screen">
                                <i className="action-cursor fas fa-arrow-alt-circle-up"
                                   onClick={() => handlePublishing(item.id)}
                                >
                                </i>
                            </Tooltip>
                            <Tooltip title="Remove campaign">
                            <i
                            className="fas fa-trash-alt action-cursor ml-3"
                            style={{cursor: "pointer"}}
                            onClick={() => handleDelete(item.id)}
                            ></i>
                            </Tooltip>
                        </Td>
                    </Tr>
                );
            });
        }
    }

    const handleDelete = (id) => {
        setCampaignId(id);
        setconfirm_both(true);
    }

    const deleteCampaign = () => {
        paramPost('api/v1/campaigns/remove_campaign', {id: campaignId})
            .then((result) => {
                if(result.status === 200) {
                    setsuccess_dlg(true);
                    setdynamic_title("Deleted");
                    setdynamic_description("Campaign deleted successfully");
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else if(result.status === 422) {
                    const screenNames = result.data.screens;
                    let nameString = "";
                    screenNames.forEach((item, index) => {
                        nameString += item;
                        if(index !== screenNames.length -1) {
                            nameString += ", "
                        }
                    })
                    setdynamic_title("Failed");
                    setdynamic_description(`This campaign is used in "${screenNames}" Screens`);
                    seterror_dlg(true);
                } else {
                    setdynamic_title("Error");
                    setdynamic_description("Something went wrong. Try again");
                    seterror_dlg(true);
                }
            })
            .catch((err) => {
                setdynamic_title("Error");
                setdynamic_description("Something went wrong. Try again");
                seterror_dlg(true);
            })
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="table-rep-plugin">
                        <div
                            className="table-responsive mb-0"
                            data-pattern="priority-columns"
                        >
                            <Table
                                id="tech-companies-1"
                                className="table table-striped table-bordered content-table"
                            >
                                <Thead>
                                    <Tr>
                                        <Th data-priority="1">Campaign Name</Th>
                                        <Th data-priority="1">Campaign</Th>
                                        <Th data-priority="1">Number of contents</Th>
                                        <Th data-priority="1">Created At</Th>
                                        <Th data-priority="1">Action</Th>
                                    </Tr>
                                </Thead>

                                {!props.loading && (
                                    <Tbody className="">{campaignList()}</Tbody>
                                )}
                            </Table>
                            {props.loading && (
                                <div className="loading-icon">
                                    <i className="fas fa-sync fa-spin"></i>
                                </div>
                            )}
                        </div>
                    </div>
                </Container>
            </div>
            {confirm_both ? (
                <SweetAlert
                    title={"Are you sure?"}
                    warning
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {
                        setconfirm_both(false);
                        deleteCampaign();
                    }}
                    onCancel={() => {
                        setconfirm_both(false);
                        setsuccess_dlg(false);
                        setdynamic_title("Cancelled");
                        setdynamic_description("Your imaginary file is safe :)");
                    }}
                >
                    Delete this campaign?
                </SweetAlert>
            ) : null}

            {success_dlg ? (
                <SweetAlert
                    success
                    title={dynamic_title}
                    onConfirm={() => {
                        setsuccess_dlg(false);
                    }}
                >
                    {dynamic_description}
                </SweetAlert>
            ) : null}

            {error_dlg ? (
                <SweetAlert
                    error
                    title={dynamic_title}
                    onConfirm={() => {
                        seterror_dlg(false);
                    }}
                >
                    {dynamic_description}
                </SweetAlert>
            ) : null}

            <Modal isOpen={editModal} role="dialog" backdrop={"static"} autoFocus={true} centered={true} className="myModal" tabIndex="-1" toggle={() => clear()}>
                <div className="modal-content">
                    <ModalHeader toggle={() => clear()}>
                        Publish Campaign
                    </ModalHeader >
                    <ModalBody>
                        <div className="table-rep-plugin">
                            <div
                                className="table-responsive mb-0"
                                data-pattern="priority-columns"
                            >
                                <Table
                                    id="tech-companies-1"
                                    className="table table-striped table-bordered"
                                >
                                    <Thead>
                                        <Tr>
                                            <Th data-priority="1">Player Name</Th>
                                            <Th data-priority="1">Created At</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody className="">{contentList()}</Tbody>
                                </Table>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" color="secondary" onClick={() => clear()}>Close</button>
                        <button
                            disabled={pending ? true : false}
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={() => handlePublishingSave()}
                        >
                            {pending ? (
                                <React.Fragment>
                                    <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                    Publishing...
                                </React.Fragment>
                            ) : "Publish"}
                        </button>
                    </ModalFooter>
                </div>
            </Modal>

        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { saved_campaigns, loading } = state.SavedCampaigns;
    const { playerList } = state.ScreenReducer;
    return { saved_campaigns, loading, playerList };
}

export default withRouter(connect(mapStateToProps, { getSavedCampaigns, getPlayerList })(withNamespaces()(SavedCampaigns)));
